@if (data.type != 'notice') {
  <h2 mat-dialog-title>{{data.title}}</h2>
}
@if (data.type === 'notice') {
  <h1 mat-dialog-title class="text-center notice-title my-m" color="primary">{{data.title}}</h1>
}
@if (data.icon) {
  <div class="text-center icn" >
    <mat-icon fontSet="material-symbols-outlined" aria-hidden="false" color="primary">{{data.icon}}</mat-icon>
  </div>
}
<mat-dialog-content><div [innerHTML]="data.content"></div></mat-dialog-content>
<mat-dialog-actions class="mx-m">


  @if (data.type === 'alert' || data.type ==='confirm') {
    <button mat-flat-button mat-dialog-close >Schliessen</button>
  }

  <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
  @if (data.type === 'confirm') {
    <button mat-flat-button [mat-dialog-close]="true" color="primary">{{data.ok}}</button>
  }
</mat-dialog-actions>
